import { useState } from 'react';
import { DEFAULT_THIS_YEAR_PERIOD } from '@/helpers/date';
import { ReportDownloadModal } from '@/modals/ReportDownloadModal';
import { Filters } from './components/Filters';
import { DataView } from './components/DataView';
import s from './index.module.scss';

const TaxReportPage = () => {
  const [params, setParams] = useState({
    range: DEFAULT_THIS_YEAR_PERIOD,
  });

  return (
    <div className={s.page}>
      <Filters params={params} setParams={setParams} />
      <DataView params={params} setParams={setParams} />
      <ReportDownloadModal type="tax_report" params={params} />
    </div>
  );
};

export default TaxReportPage;
